import {Alert as MuiAlert} from '@mui/material'
interface IAlertProps {
    messageSuccess: string | null;
    messageError: string | null;
    onClose: () => void;
}

export const Alert = ({messageSuccess, messageError, onClose} :IAlertProps) => {
    return (
        <>
       {messageSuccess && <MuiAlert severity="success" onClose={onClose}>{messageSuccess}</MuiAlert>}
       {messageError && <MuiAlert severity="error" onClose={onClose}>{messageError}</MuiAlert>}
        </>
    )
}